module.exports = __webpack_public_path__ + "whatsapp.png?953a8c3e23cfd7540f2741454b1f61ea";


//////////////////
// WEBPACK FOOTER
// ./src/assets/whatsapp.png
// module id = 207
// module chunks = 130